export enum EAirQFType {
    Standard = 1,
    BPP = 2,
    BPPH = 3,
    ComptageParticulaire = 4
}